/* Keep server-rendered review text and ratings; start the full widget near the viewport. */
(function () {
  function setup() {
    document.querySelectorAll('[data-pdp-reviews-lazy]').forEach(function (widget) {
      if (widget.dataset.lazyBound) return;
      widget.dataset.lazyBound = 'true';
      var root = widget.closest('#product-reviews'), observer, loading = false;
      function waitFor(ready) {
        return new Promise(function (resolve, reject) {
          var attempts = 0;
          function check() {
            if (!widget.isConnected) return reject(new Error('Widget removed'));
            if (ready()) return resolve();
            if (++attempts > 100) return reject(new Error('Review app unavailable'));
            setTimeout(check, 100);
          }
          check();
        });
      }
      function activate() {
        if (loading) return;
        loading = true;
        if (observer) observer.disconnect();
        waitFor(function () { return window.jdgm && jdgm.loadScript && jdgm.$ && jdgm.initializeWidgets; }).then(function () {
          widget.id = 'judgeme_product_reviews';
          widget.classList.add('jdgm-widget', 'jdgm-review-widget');
          jdgm.loadCSS(jdgm.widgetPath('main.css'));
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/main.js');
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/media.js');
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/form.js');
          jdgm.loadScript(jdgm.CDN_HOST + 'widget/write_review_modal.js');
          jdgm.loadCSS(jdgm.widgetPath('form.css'));
          return waitFor(function () {
            return jdgm._setupLoadReviewsEventsFor && jdgm.setupMediaGallery && jdgm._renderAndSetupReviewForm && jdgm._setupQuestionsForm && jdgm._setupFormsSubmit;
          });
        }).then(function () {
          // The app's initial badge scan ran before this full widget was activated.
          jdgm.caches.$revWidgets = jdgm.$('.jdgm-review-widget, [data-widget="review"]');
          jdgm.caches.$widgetWithReviews = jdgm.$('.jdgm-review-widget, .jdgm-revs-tab, .jdgm-all-reviews-widget');
          jdgm.eachWidgetWithReviews(function (item) {
            if (item[0] !== widget) return;
            jdgm.initializeWidgets(jdgm.$(root));
            widget.classList.remove('pdp-reviews-pending');
            widget.removeAttribute('data-pdp-reviews-lazy');
          });
        }).catch(function () {
          // Reviews remain readable if the app/CDN is unavailable; retry on interaction.
          loading = false;
        });
      }
      root.addEventListener('pdp:load-reviews', activate);
      root.addEventListener('pointerdown', activate, {passive: true});
      root.addEventListener('focusin', activate);
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) activate();
        }, {rootMargin: '500px 0px'});
        observer.observe(root);
      } else activate();
      if (/^#(ocene|mnenja|reviews|product-reviews|judgeme|judgeme_product_reviews)$/.test(location.hash)) activate();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once: true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
